export default __webpack_public_path__ + "static/media/live-chat-blue.bae55712.svg";